import { render, staticRenderFns } from "./AcessarCartorio.vue?vue&type=template&id=690025e4&"
import script from "./AcessarCartorio.vue?vue&type=script&lang=js&"
export * from "./AcessarCartorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports